module.exports = __webpack_public_path__ + "static/media/clock.f5f2577f.svg";